import { INSPECTION_CHECKLIST_STEPS } from "../inspection-form.catalog";
import type { InspectionChecklistStepWrapperProps } from "./checklistStep.props";
import InspectionChecklistStep from "./InspectionChecklistStep";

const InspectionSpillwayStep = (props: InspectionChecklistStepWrapperProps) => (
  <InspectionChecklistStep step={INSPECTION_CHECKLIST_STEPS.spillway} {...props} />
);

export default InspectionSpillwayStep;
